import { render, staticRenderFns } from "./kdvkoducomp.vue?vue&type=template&id=5fb6942b&"
import script from "./kdvkoducomp.vue?vue&type=script&lang=js&"
export * from "./kdvkoducomp.vue?vue&type=script&lang=js&"
import style0 from "./kdvkoducomp.vue?vue&type=style&index=0&id=5fb6942b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports